import { useEffect, useContext, useState } from "react";
import { AlertContext } from "../contexts/AlertContext";
import { LoaderContext } from "../contexts/LoaderContext";
import { getSessionstorage, removeSessionStorage } from "../helpers/sessionStorage";

export const useAuth = () => {
    
    const [usuario, setUsuario] = useState(null);
    const { alertRef } = useContext(AlertContext);
    const { setOpenLoader } = useContext(LoaderContext);

    useEffect(() => {
        let subscribed = true;
        subscribed && validarLogin();

        return () => subscribed = false;
    }, []);

    const validarLogin = async () => {
        setOpenLoader(true);
        
        const token = await getSessionstorage("token");

        if (!token) {
            setOpenLoader(false);
            return;
        }

        const response = await fetch(`/api/auth/`, {
            headers: {
                token
            }
        });

        if(!response?.ok) {
            setOpenLoader(false);
            alertRef?.current?.handleOpen('error', 'Error de conexión con el servidor.');
            return;
        }
        
        const { ok, message, data } = await response.json();

        if(!ok) {
            setOpenLoader(false);
            alertRef?.current?.handleOpen('error', message);
            return;
        }

        setUsuario(data?.user);
        setOpenLoader(false);
    };

    const cerrarSesion = async () => {
        setOpenLoader(true);
        await removeSessionStorage();
        setUsuario(null);

        setTimeout(() => setOpenLoader(false), 1000);
    };

    return {
        usuario,
        validarLogin,
        cerrarSesion
    };
}